import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  newCommunityWrapper: {},
  newCommunityForm: {
    ...theme.mixins.appContainer,
    width: '100%',
    '& > div + div, & > button + div, & > div + button': {
      marginTop: theme.spacing(1),
    },
  },
  avatarWrapper: {
    '& img': {
      maxWidth: '100px',
      maxHeight: '100px',
    },
  },
  title: {
    ...theme.mixins.appEllipsis,
    fontWeight: '500',
    fontStyle: 'normal',
    color: theme.palette.grey[600],
    paddingBottom: '4px',
  },
  uploadFileButton: {
    height: '32px',
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: '4px',
    '& svg': {
      marginRight: '8px',
    },
  },
  buttonWrapper: {
    padding: '16px 0',
  },
}));
